var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualaddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5639 6.76361C14.5639 9.14678 12.5563 11.0787 10.0799 11.0787C7.60349 11.0787 5.59595 9.14678 5.59595 6.76361C5.59595 4.38043 7.60349 2.44849 10.0799 2.44849C12.5563 2.44849 14.5639 4.38043 14.5639 6.76361ZM13.0692 6.76361C13.0692 8.35239 11.7309 9.64036 10.0799 9.64036C8.42896 9.64036 7.0906 8.35239 7.0906 6.76361C7.0906 5.17482 8.42896 3.88686 10.0799 3.88686C11.7309 3.88686 13.0692 5.17482 13.0692 6.76361Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11751 12.9296C7.03886 12.249 8.32298 11.7979 10.0799 11.7979C11.8369 11.7979 13.121 12.249 14.0424 12.9296C14.9568 13.6051 15.4543 14.4625 15.7241 15.1843C15.9615 15.8196 15.7952 16.4415 15.397 16.8822C15.0124 17.3078 14.4302 17.5514 13.8165 17.5514H6.3433C5.72964 17.5514 5.1474 17.3078 4.76284 16.8822C4.36463 16.4414 4.19828 15.8196 4.43575 15.1843C4.70556 14.4625 5.20305 13.6051 6.11751 12.9296ZM7.0276 14.0706C6.39825 14.5355 6.04318 15.1334 5.84217 15.6711C5.80023 15.7834 5.8233 15.8637 5.89075 15.9384C5.97184 16.0281 6.13147 16.113 6.3433 16.113H13.8165C14.0284 16.113 14.188 16.0281 14.2691 15.9384C14.3365 15.8637 14.3596 15.7834 14.3177 15.6712C14.1167 15.1334 13.7616 14.5355 13.1323 14.0706C12.5098 13.6108 11.5589 13.2363 10.0799 13.2363C8.60103 13.2363 7.65008 13.6107 7.0276 14.0706Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualaddress);
export default __webpack_public_path__ + "static/media/individualaddress.37d2fbdad0d11907f384f9696ae00cc9.svg";
export { ForwardRef as ReactComponent };